const isDevelopment = () => process.env.NEXT_PUBLIC_WAMAZING_ENV === 'development';

const isProduction = () => process.env.NEXT_PUBLIC_WAMAZING_ENV === 'production';

const isStaging = () => process.env.NEXT_PUBLIC_WAMAZING_ENV === 'staging';

const isBrowser = () => typeof window !== 'undefined';

const cacheKey = () => process.env.STATIC_FILE_CACHE_KEY || new Date().getTime().toString();

const getGtmId = (): string => {
  if (isProduction()) {
    return 'GTM-W36X3G4';
  }

  if (isStaging()) {
    return 'GTM-MBDZ56H';
  }

  return '';
};

export { cacheKey, getGtmId, isBrowser, isDevelopment, isProduction, isStaging };
